import { createFileRoute } from '@tanstack/react-router';
import PublicLayout from '@components/layout/PublicLayout';
import ScheduledOrderAction from '@features/client/scheduled-orders/ScheduledOrderAction.tsx';

export const Route = createFileRoute('/scheduled-order-action/$code/dispatch-now')({
  component: RouteComponent,
});

function RouteComponent() {
  const { code } = Route.useParams();

  return (
    <PublicLayout>
      <ScheduledOrderAction code={code} autoAction="dispatch-now" />
    </PublicLayout>
  );
}
